<template>
  <div class="faq">
    <Modal
      v-model="modalEditImage"
      title="替换图片"
      :closable="false"
      :mask-closable="false"
      @on-ok="editRecordImage"
    >
      <p>图片：{{upload_image_name}}</p>
      <Upload action="" :before-upload="(file) =>  { return addImgRecord(file, 0)}" :multiple="true">
          <Button icon="ios-cloud-upload-outline">上传图片</Button>
      </Upload>
    </Modal>
    <Modal
      v-model="modalAdd"
      title="新增商品"
      :closable="false"
      :mask-closable="false"
      @on-ok="addRecord"
    >
      <p>类型：</p>
      <Select v-model="addClassify" filterable>
        <Option v-for="item in filterClassify" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <p>图片-商店-shop：{{upload_image_name}}</p>
      <Upload action="" :before-upload="(file) =>  { return addImgRecord(file, 0)}" :multiple="true">
          <Button icon="ios-cloud-upload-outline">上传图片</Button>
      </Upload>
	  <p>时长：(单位min)</p>
	  <Input v-model="addUseDuration" placeholder="请输入时长：(单位min)" clearable />
      <p>用钻价格：</p>
      <Input v-model="addJewelPrice" placeholder="请输入用钻价格" clearable />
      <p>用币价格：</p>
      <Input v-model="addCoinPrice" placeholder="请输入用币价格" clearable />
      <p>状态：</p>
      <Select v-model="addStatus" filterable>
        <Option v-for="item in filterStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <!-- <Checkbox v-model="isUpdateTime">是否更新时间</Checkbox> -->
      <p>备注：用钻购买价格，-1为不可用钻购买；用币购买价格，-1为不可用币购买</p>
    </Modal>
    <div class="headers">
      <span>分类：</span>
      <Select @on-change="changeSelect" v-model="classify" style="width: 120px">
        <Option
          v-for="item in filterClassify"
          :value="item.value"
          :key="item.value"
        >{{ item.label }}</Option>
      </Select>
      <Button @click="modalAdd = true">新增</Button>
       <Button @click="getRecords()">刷新</Button>
    </div>
    <Table :columns="columns" :data="data">
		<template slot-scope="{ row, index }" slot="id">
		  <span>{{ row.id }}</span>
		</template>
		// 用于点击
		<template slot-scope="{ row, index }" slot="url">
		    <Poptip trigger="hover" :transfer="true" title="图片详情">
		        <div class="info-pop" slot="content">
		            <img :src="row.url">
		        </div>
		        <img :src="row.url" style="width: 50px;height: 50px;">
		    </Poptip>
		</template>
      <template slot-scope="{ row, index }" slot="priority">
        <span>{{ row.priority }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="category_id">
        <template v-if="editIndex === index">
          <Select v-model="updateClassify" filterable>
            <Option v-for="item in filterClassify" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <span v-else>{{ row.category_id|getClassify }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="use_duration">
           <span >{{ row.use_duration|getDuration }}</span>
         <!-- <template v-if="editIndex === index">
            <i-Input v-model="updateUseDuration" />
          </template>
          <span v-else>{{ row.use_duration|getDuration }}</span> -->
      </template>

      <template slot-scope="{ row, index }" slot="jewel_price">
        <template v-if="editIndex === index">
          <i-Input v-model="updateJewelPrice" />
        </template>
        <span v-else>{{ row.jewel_price }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="coin_price">
        <template v-if="editIndex === index">
          <i-Input v-model="updateCoinPrice" />
        </template>
        <span v-else>{{ row.coin_price }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="status">
        <template v-if="editIndex === index">
          <Select v-model="updateStatus" filterable>
            <Option v-for="item in filterStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <span v-else>{{ row.status|getStatus }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="action">
        <div v-if="editIndex === index">
            <Button @click="handleSave(index)" :disabled="action_btn_disabled">保存</Button>
            <Button
              style="margin-left: 10px"
              @click="editIndex = -1"
              :disabled="action_btn_disabled"
            >取消</Button>
        </div>
        <div v-else>
          	<Button @click="handleToTop(row, index)">置顶</Button>
            <Button  style="margin-left: 10px" @click="handleEdit(row, index)">修改</Button>
             <Button style="margin-left: 10px" @click="editImages(row, index)">替图</Button>
        </div>
       <!-- <div v-if="!sorting">
          
        </div>
        <div v-else>
          <Button
            :disabled="index === 0"
            style="border-radius: 50%"
            @click="handel_sort(row,index,'up')"
          >上</Button>
          <Button
            :disabled="index === data.length -1"
            style="border-radius: 50%;margin-left: 5px"
            @click="handel_sort(row,index,'down')"
          >下</Button> -->
        <!-- </div> -->
      </template>
    </Table>
  </div>
</template>

<script>
import apis from "../../http/api";
import OSS from 'ali-oss';

export default {
  name: "faq",
  data() {
    return {
	  ossClient: null,
      upload_image_data:null,
      upload_image_name:null,
	  
      filterStatus: [{ label: '正常', value: 0 }, { label: '下架', value: -1 }, { label: '赠品', value: -2 }],
      filterClassify: [{ label: '奶茶咖啡', value: 1 }, { label: '小吃快餐', value: 2 }, { label: '面包甜点', value: 3 },
        { label: '各式菜系', value: 4 }, { label: '西餐', value: 5 }],
      classify: 1,
      
      data: [],
      tmpData: [],
      modalAdd: false,
      modalEditImage: false,
      action_btn_disabled: false,
      sortSaveBtn: false,
      update_question: "",
      update_answer: "",
      update_faq_id: null,
      editIndex: -1,
	  
	  // 新增
      addClassify: 1,
      addImages: "",
      addUseDuration: 0,
      addJewelPrice: null,
      addCoinPrice: null,
      addStatus: 0,
	  
      updateClassify:'',
      updateUseDuration: 0,
      updateJewelPrice: null,
      updateCoinPrice: null,
      updateStatus: 0,
      
      replaceFoodId: 0,
      
      columns: [
		  {
		    title: 'ID',
		    slot: 'id',
		    width: 80
		  },
		  {
		    title: '缩略图',
		    slot: 'url',
		    width: 0
		  },
        {
          title: '优先级',
          slot: 'priority',
          width: 80
        },
        {
          title: '类型',
          slot: 'category_id',
          // width: 120
        },
        {
          title: '时长/min',
          slot: 'use_duration',
          // width: 170
        },
        {
          title: '用钻价格',
          slot: 'jewel_price',
          // width: 170
        },
        {
          title: '用币价格',
          slot: 'coin_price',
          // width: 170
        },
        {
          title: '状态',
          slot: 'status',
          // width: 170
        },
        {
          title: '操作',
          slot: 'action',
          width: 240
        }
      ]
    }
  },
  async created() {
	this.getOss();
    await this.getRecords()
  },
  watch: {
    // 如果退出编辑将多选框置为false
    editIndex: function (newVal, oldVal) {
      if (newVal === -1) {
        this.isUpdateTime = false
      }
    },
    modalAdd: function (newVal, oldVal) {
      if (newVal) {
        this.addClassify = this.classify;
        this.addSex = this.sex !== -1 ? this.sex : 1
      }
    }
  },
  methods: {
	async getOss() {
	    apis.get_oss().then(res => {
	        this.ossClient = new OSS({
	            region: 'oss-cn-shanghai',
	            accessKeyId: res.AccessKeyId,
	            accessKeySecret: res.AccessKeySecret,
	            stsToken: res.SecurityToken,
	            bucket: 'co-study',
	        })
	    }).catch(err => {
	        console.log(err)
	    })
	},
    async addImgRecord(event, type) {
        try {
    		console.log(type)
            let ts = (new Date()).valueOf();
            let filename = '.' + event.name.split('.').pop();
            if(filename !== '.png'){
                this.$Message.error('仅支持上传png格式的图片');
                return Promise.reject()
            }
    		
    		let file_key = event.name.split('.')[0]
    		var keys = ['shop','eat']
    		if (!keys.find(item => item===file_key)) {
    			this.$Message.error('图片名称错误'+file_key);
    			return Promise.reject()
    		}		
    		
    		let timestamp = Date.now()
    		timestamp =  parseInt(timestamp/1000)
    		
    		let min = 1000
    		let max = 9999
    		parseInt(Math.random()*(max-min+1)+min,10);
    		let random = Math.floor(Math.random()*(max-min+1)+min);
    		
    		filename =  timestamp +'_' + random
    		
    		filename = filename + '.png'
    		if (this.classify === null) {
    		    this.$Message.error('请先选择类型');
    		    return Promise.reject()
    		}
    		if (type == 0) {
    			if (this.upload_image_name === null) {
    				this.upload_image_name = ''
    			}
    			this.upload_image_name += event.name + '\n'
    			if (this.upload_image_data === null) {
    				this.upload_image_data = []
    			}
    			this.upload_image_data.push({'key':event.name.split('.')[0], 'filename':filename, 'data':event})
    		}
        } catch (e) {
            console.log(e);
            this.$Message.error('失败');
        }
        return Promise.reject()
    },
    async upload_image_to_oss(){
    	let oss_url = 'app/image/restaurant/food/'
    	let result = null
    	
    	if (!this.upload_image_data) {
    		console.log('no image')
    		return true
    	}else{
    		console.log('start upload image')
    	}
    	
    	
    	for (let i = 0; i < this.upload_image_data.length; i++) {
    		let tmp_dict = this.upload_image_data[i]
    		console.log(tmp_dict['filename'])
    		result = await this.ossClient.put(oss_url + tmp_dict['filename'], tmp_dict['data']);
    		if (result.res.status === 200) {
    			this.$Message.success('上传成功');
    		} else {
    			console.log(tmp_dict['key'])
    		    return false
    		}
    	}
    	return true
    },
    async getRecords() {
      let params = {
        'category_id': this.classify,
      }
      apis.restaurant_food_records(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.data = data.records
        }
      }).catch(err => {

      })
    },
    async addRecord() {
	  if (!this.upload_image_name) {
	    this.$Message.error('图片不能为空');
	    return
	  }
      if (!this.addUseDuration) {
        this.$Message.error('时长不能为空');
        return
      }
      if (!this.addJewelPrice) {
        this.$Message.error('钻价格不能为空');
        return
      }
      if (!this.addCoinPrice) {
        this.$Message.error('币价格不能为空');
        return
      }
      let upload_result = await this.upload_image_to_oss()
        if (!upload_result) {
            this.$Message.error('图片上传失败');
            return
      }
      var images_dict = {}
      if (this.upload_image_data) {
          for (let i = 0; i < this.upload_image_data.length; i++) {
            let tmp_dict = this.upload_image_data[i]
                images_dict[tmp_dict['key']] = tmp_dict['filename']
          }
      }
      
      this.upload_image_data = null
      this.upload_image_name = null
      
	  console.log(images_dict)
	  this.addImages = JSON.stringify(images_dict)
      let post_data = {
        category_id: this.addClassify,
        images: this.addImages,
        use_duration: this.addUseDuration,
        jewel_price: this.addJewelPrice,
        coin_price: this.addCoinPrice,
        status: this.addStatus,
      }
	  console.log(post_data)
      await apis.restaurant_food_create(post_data).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.addImages = ""
          this.addJewelPrice = null
          this.addCoinPrice = null
          this.addUseDuration = 0
          this.upload_image_data = null
          this.upload_image_name = null
        }else {
          this.$Message.error(msg);
        }
      }).catch(res => {
        this.$Message.error(res.toString());
      })

      await this.getRecords()
    },
    updateRecord(index) {
      if (!this.updateUseDuration) {
        this.$Message.error('时长不能为空');
        return
      }
      if (!this.updateJewelPrice) {
        this.$Message.error('钻价格不能为空');
        return
      }
      if (!this.updateCoinPrice) {
        this.$Message.error('币价格不能为空');
        return
      }
      let post_data = {
        id: this.data[index].id,
        category_id: this.updateClassify,
        jewel_price: this.updateJewelPrice,
        coin_price: this.updateCoinPrice,
        use_duration: this.updateUseDuration,
        status: this.updateStatus,
      }
      console.log(post_data)
      apis.restaurant_food_update(post_data).then(res => {
        const { data, errCode, msg } = res;
        if (errCode !== 0){
          this.$Message.error(msg);
        }
        this.getRecords()
      })
    },
    editImages(row, index) {
    	console.log(row, index)
    	this.replaceFoodId = row.id
    	this.modalEditImage=true
    },
    async editRecordImage() {
    	console.log('xxxxx')
    	let upload_result = await this.upload_image_to_oss()
    	if (!upload_result) {
    			  this.$Message.error('图片上传失败');
    			  return
    	}
    	var images_dict = {}
    	if (this.upload_image_data) {
    			  for (let i = 0; i < this.upload_image_data.length; i++) {
    			  	let tmp_dict = this.upload_image_data[i]
    			  		images_dict[tmp_dict['key']] = tmp_dict['filename']
    			  }
    	}
    	this.upload_image_data = null
    	this.upload_image_name = null
        console.log(images_dict)
    	let post_data = {
    	  images: JSON.stringify(images_dict),
    	  id: this.replaceFoodId
    	}
    	console.log(post_data)
    	apis.restaurant_food_update(post_data).then(res => {
    	  const { data, errCode, msg } = res;
    	  if (errCode !== 0){
    	    this.$Message.error(msg);
    	  }
    	  this.getRecords()
    	})
    	
    },
	restaurantFoodSortToTop(index) {
	 
	  let post_data = {
	    food_id: this.data[index].id,
	  }
	  apis.restaurant_food_sort_top(post_data).then(res => {
	    const { data, errCode, msg } = res;
	    if (errCode !== 0){
	      this.$Message.error(msg);
	    }
	    this.getRecords()
	  })
	},
    handleEdit(row, index) {
      this.action_btn_disabled = false;
      this.updateClassify = row.category_id;
      console.log(row.classify);
      // 需要转化为分钟min
      this.updateUseDuration = row.use_duration/60;
      this.updateJewelPrice = row.jewel_price;
      this.updateCoinPrice = row.coin_price;
      this.updateStatus = row.status;
      console.log(row.status)
      this.editIndex = index;
    },
    handleSave(index) {
      this.action_btn_disabled = true;
      this.updateRecord(index);
      this.editIndex = -1;
    },
    async changeSelect() {
      await this.getRecords()
    },
	handleToTop(row, index) {
	  this.restaurantFoodSortToTop(index);
	}
  },
  computed: {
   
  },
  filters:{
    getClassify(val){
      let categoryClassifyMap = {1: '奶茶咖啡', 2: '小吃快餐', 3: '面包甜点', 4: '各式菜系', 5: '西餐'}
      return categoryClassifyMap[val]
    },
    getDuration(val){
		return val/60
    },
    getStatus(val) {
      if(val === 0){
        return '正常'
      }else if(val === -1){
        return '下架'
      } else if(val === -2){
        return '赠品'
      } else {
        return '异常'
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.faq /deep/ .ivu-table-cell {
  min-height: 33px;
  display: flex;
  justify-content center;
  align-items: center;
}

.faq {
  margin: 10px;
}

.headers {
  text-align: center;
  margin-bottom: 10px;
}

.headers button {
  margin-left: 10px;
}

.images-text {
  white-space: pre-wrap;
}

</style>